import React from 'react'
import Footer from '../Footer'
import Breadcrumbs from '../Breadcrumbs'
import '../../css/documentacionViaje.scss'
import { Link } from "react-router-dom";

export default function DocumentacionParaViajar() {

    return (
        <>
        <section className='documentacion-viaje'>

                {/* HERO */}
                <div className='documentacion-hero'>

                    <div className='overlay'></div>

                    <div className='container hero-content'>

                        <div style={{ marginTop: '4rem' }}>
                            <Breadcrumbs />
                        </div>

                        <h1>Documentación para viajar</h1>

                        <p>
                            Conoce los requisitos y documentos necesarios
                            para abordar tu viaje de manera rápida y segura.
                        </p>

                    </div>

                </div>

                {/* CONTENT */}
                <div className='container documentacion-content'>

                    <div className='documentacion-layout'>

                        {/* LEFT */}
                        <div className='documentacion-main'>

                            {/* REQUISITOS */}
                            <section>

                                <div className='section-title'>
                                    <i className="fi fi-rs-document-signed"></i>
                                    <h2>Requisitos obligatorios</h2>
                                </div>

                                <p className='section-description'>
                                    Para poder embarcar, cada pasajero debe presentar
                                    la siguiente documentación original:
                                </p>

                                <div className='requirements-grid'>

                                    <div className='requirement-card'>
                                        <i className="fi fi-rs-ticket"></i>

                                        <h3>Pase de abordar</h3>

                                        <p>
                                            Documento original generado tras su compra.
                                            Puede presentarse en formato físico o digital.
                                        </p>
                                    </div>

                                    <div className='requirement-card'>
                                        <i className="fi fi-rs-id-card"></i>

                                        <h3>Identificación oficial</h3>

                                        <p>
                                            Puede ser: INE, pasaporte, licencia de conducir,
                                            cartilla militar o cédula profesional.
                                        </p>
                                    </div>

                                </div>

                            </section>

                            
                            

                            {/* CERTIFICADO MÉDICO */}
                            <section className='medical-section'>

                                <div className='section-title'>
                                    <i className="fi fi-rs-doctor"></i>
                                    <h2>Certificado médico</h2>
                                </div>

                                <p className='section-description'>
                                    <strong>Solo es necesario si el pasajero presenta alguna de las siguientes condiciones:</strong>
                                </p>

                                <ul className='medical-list'>
                                    <li>
                                        Enfermedades cardiovasculares, respiratorias, neurológicas o
                                        metabólicas no controladas.
                                    </li>

                                    <li>
                                        Cirugías o procedimientos médicos recientes (últimos 30 días).
                                    </li>

                                    <li>
                                        Requerimiento de oxígeno, dispositivos médicos o supervisión
                                        constante (estos no serán proporcionados por el buque).
                                    </li>

                                    <li>
                                        Episodios recientes (últimos 6 meses) de desmayos,
                                        convulsiones o pérdida de conciencia.
                                    </li>

                                    <li>
                                        Condiciones que puedan agravarse durante una travesía
                                        marítima de aproximadamente 14 horas.
                                    </li>

                                    <li>
                                        Limitaciones de movilidad (se recomendará considerar el uso
                                        de silla de ruedas y/o acompañante).
                                    </li>

                                    <li>
                                        Enfermedades infecciosas.
                                    </li>

                                    <li>
                                        Pasajeras embarazadas hasta la semana 28 de embarazo.
                                        No se permite viajar a partir de la semana 28 (7 meses).
                                    </li>
                                </ul>

                            </section>

                            {/* SITUACIONES */}
                            <section className='special-section'>

                                <h2>Situaciones especiales</h2>

                                <div className='special-grid'>

                                    <div className='special-item'>

                                        <div className='special-header'>
                                            <i className="fi fi-rs-family"></i>
                                            <h4>Menores de edad</h4>
                                        </div>

                                        <p>
                                            Los menores deben viajar con identificación adecuada.
                                            Si viajan sin padres o tutores legales,
                                            requerirán carta de consentimiento firmada.
                                        </p>

                                    </div>

                                    <div className='special-item'>

                                        <div className='special-header'>
                                            <i className="fi fi-rs-passport"></i>
                                            <h4>Extranjeros</h4>
                                        </div>

                                        <p>
                                            Deben presentar pasaporte y boleto.
                                            También pueden requerir la
                                            <a
                                                href="https://www.gob.mx/tramites/ficha/internacion-al-territorio-nacional-de-personas-extranjeras-titulares-de-una-visa-ordinaria-valida-y-vigente-expedida-por-el-gobierno-mexicano/INM619"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {" "}Forma Migratoria Múltiple (FMM)
                                            </a>
                                            {" "}o visa vigente.
                                        </p>

                                    </div>

                                </div>

                            </section>

                            {/* NOTAS */}
                            <section className='notas-section'>

                                <div className='notas-header'>
                                    <i className="fi fi-rs-warning"></i>
                                    <h3>Notas importantes</h3>
                                </div>

                                <ul>
                                    <li>
                                        El pase de abordar no debe tener tachaduras,
                                        alteraciones o enmendaduras.
                                    </li>

                                    <li>
                                        Las oficinas de Baja Ferries se encuentran
                                        dentro de las terminales portuarias.
                                    </li>
                                </ul>

                            </section>

                        </div>

                        {/* SIDEBAR */}
                        <aside className='documentacion-sidebar'>

                            {/* RECOMENDACIONES */}
                            <div className='sidebar-card'>

                                <h3>Recomendaciones</h3>

                                <div className='recommendation-item'>

                                    <div className='recommendation-icon'>
                                        <i className="fi fi-rs-clock-three"></i>
                                    </div>

                                    <div>
                                        <strong style={{ color: '#111c2d' }}>Llegada anticipada</strong>

                                        <p>Llega al puerto con 1:30 horas de anticipación.</p>
                                        <p>Llega al puerto con 2 horas de anticipación si viajas con automóvil o motocicleta.</p>
                                        <p>Llega al puerto con 3 horas de anticipación si viajas con carga.</p>
                                    </div>

                                </div>

                                <div className='recommendation-item'>

                                    <div className='recommendation-icon'>
                                        <i className="fi fi-rs-ticket"></i>
                                    </div>

                                    <div>
                                        <strong style={{ color: '#111c2d' }}>Pase de abordar</strong>

                                        <p>
                                            Mantén tu pase siempre a la mano.
                                        </p>
                                    </div>

                                </div>

                            </div>

                            {/* TEMAS */}
                            <div className='related-topics'>

                                <h3>Temas relacionados</h3>

                                <nav>

                                    <Link to='/viajar-con-menores-de-edad'>
                                        Viajar con menores de edad
                                    </Link>

                                    <Link to='/viajar-con-auto'>
                                        Documentación para automóvil
                                    </Link>

                                    <Link to='/viajar-con-mascotas'>
                                        Requisitos para mascotas
                                    </Link>
                                    <Link to='/equipaje'>
                                       Equipaje permitido
                                    </Link>

                                </nav>

                            </div>

                        </aside>

                    </div>

                </div>

                <Footer />
            </section>
        </>
    )
}
